module.exports = __webpack_public_path__ + "d52054ba8acbb47059ef46f57357cb62.svg";


//////////////////
// WEBPACK FOOTER
// ./images/step1-green.svg
// module id = 1158
// module chunks = 0